    
import React from "react";

function Radio(props) {
  return (
    <div className="custom-control custom-radio">
      <input type="radio" id={props.id} className="custom-control-input" name={props.name} value={props.value} 
      data-target={props.collapseTarget}data-toggle="radio-collapse" checked={props.checked} onChange={props.onChange}></input>
      <label className="custom-control-label" htmlFor={props.id}>{props.children}</label>
    </div>
  );
}

export default Radio;